export const contractDeployerAddress = '0x0000000000000000000000000000000000008006';
export const legacyEthAddress = '0x0000000000000000000000000000000000000000';
export const ethAddressInContracts = '0x0000000000000000000000000000000000000001';
export const l2BaseTokenAddress = '0x000000000000000000000000000000000000800a';
//# sourceMappingURL=address.js.map